import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { LiveSessionState } from "@pcp/core/interfaces";

export const liveLessonStateActions = createActionGroup(
    {
        source: "LiveLessonActions",
        events: {
            fetchLiveLessonState: emptyProps(),
            fetchLiveLessonStateSuccess: props<{ liveLessonState: LiveSessionState }>(),
            fetchLiveLessonStateFailed: props<{ error: any }>(),

            receivedStateUpdateFromSignalr: props<{ liveLessonState: LiveSessionState }>(),
        },
    }
);
